"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Timezone = void 0;
/**
 * @important Include only the timezones used so we don't increase the bundle size.
 */
var Timezone;
(function (Timezone) {
    Timezone["Europe/London"] = "Europe/London";
    Timezone["Europe/Paris"] = "Europe/Paris";
})(Timezone = exports.Timezone || (exports.Timezone = {}));
//# sourceMappingURL=timezone.js.map